<template>
  <div>
    <a-row class="content-fix org">
      <a-row class="content-title" type="flex">
        <a-button
          type="primary"
          class="back-btn"
          @click="goBack()"
        >
          <i class="t-transition icons icon-chevron-left" />
          Назад
        </a-button>
        <a-row class="post-search" type="flex">
          <a-select
            class="table__parpage"
            option-filter-prop="children"
            placeholder="Все"
          >
            <a-select-option
              v-for="(item, index) in this.centralStatistics.data"
              :key="index"
              :value="item.period_type"
            >
              {{ item.period_type }}
            </a-select-option>
          </a-select>

          <a-button type="primary" class="all-news-btn" style="margin: 0 15px">
            Все
          </a-button>

          <a-button
            style="margin: 0 15px"
            type="primary"
            @click="
              $router.push({
                name: 'mtms-central-create'
              })
            "
          >

            <a-icon type="plus" />{{ $t("Add") }}
          </a-button>
        </a-row>
      </a-row>
      <a-table
        :columns="columns"
        :data-source="this.centralStatistics.data"
        :spinning="loading"
        row-key="id"
      >
        <div slot="title" slot-scope="item" style="cursor: pointer">
          {{ item.title }}
        </div>
        <div slot="month" slot-scope="item" style="cursor: pointer">
          {{ getMonthTitle(item.month) }}
        </div>
        <div slot="publication_date" slot-scope="item" style="cursor: pointer">
          {{ item.publication_date }}
        </div>

        <template slot="operation" slot-scope="item">
          <div class="action">
            <a-button
              class="edit-btn"
              type="primary"
              @click="
                $router.push(
                  {
                    name: 'mtms-central-detail',
                    params: { id: item.id }
                  },
                  () => null
                )
              "
            >

              <a-icon class="action-btns" type="edit" />
            </a-button>

            <a-button type="danger" @click="removeItem(item.id)">
              <a-icon class="action-btns" type="delete" />
            </a-button>
          </div>
        </template>
      </a-table>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      mergedData: [],
      loading: false,
      month: [
        { title: "January" },
        { title: "February" },
        { title: "March" },
        { title: "April" },
        { title: "May" },
        { title: "June" },
        { title: "July" },
        { title: "August" },
        { title: "September" },
        { title: "October" },
        { title: "November" },
        { title: "December" }
      ],
      columns: [
        {
          title: "Title",
          scopedSlots: { customRender: "title" }
        },
        {
          title: "Month",
          scopedSlots: { customRender: "month" }
        },
        {
          title: "Publication Date",
          scopedSlots: { customRender: "publication_date" }
        },
        {
          title: "Operation",
          scopedSlots: { customRender: "operation" }
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      centralStatistics: "mtms/centralStatistics"
    })
  },

  async mounted() {
    this.loading = true
    const year = this.$route.params.year
    await this.getCentralStat(year)
    this.loading = false
  },

  methods: {
    ...mapActions({
      getCentralStat: "mtms/getCentralStat"
    }),
    goBack() {
      this.$store.dispatch("mtms/resetStat")
      this.$router.push({ name: "mtms-year" })
    },
    getMonthTitle(monthIndex) {
      // monthIndex is expected 1-12
      if (!monthIndex || monthIndex < 1 || monthIndex > 12) return "" // safety check
      const monthTitle =
        (this.month[monthIndex - 1] && this.month[monthIndex - 1].title) || ""
      return this.$t(monthTitle)

    },
    async removeItem(id) {
      try {
        // Dispatch the Vuex action to delete the item
        const res = await this.$api.delete(
          `/admin/common/central-statistics/${id}`
        )
        // Check the API response and display appropriate feedback
        if (res && res.status === 204) {
          this.$message.success("Успешно удалено") // Success message
          this.loading = true
          const year = this.$route.params.year
          await this.getCentralStat(year)
          this.loading = false
        } else {
          this.$message.error("Не удалось удалить элемент. Повторите попытку.") // Error message
        }
      } catch (error) {
        // Log and display an error notification
        console.error(`Error deleting item with ID ${id}:`, error)
        this.$message.error("Произошла ошибка при удалении элемента.")
      }
    }
  }
}
</script>

<style>
.wanted-search-input-wrapper {
  flex: 0 0 430px;
  justify-content: space-around;
}
</style>
